import React from "react";

import constructionBg from "../../../assets/img/kalispell mt construction.png";

const strategicLendingItems = [
  {
    title: "Preferred Lender Programs",
    description: "Sales-aligned programs that improve buyer readiness, strengthen conversion, and support absorption.",
  },
  {
    title: "Forward Commitments",
    description: "Rate certainty strategies that improve affordability while helping protect margin.",
  },
  {
    title: "Backup Lender Support",
    description: "Reliable capital and execution when timing, certainty, and buyer experience matter most.",
  },
];

const StrategicLending = () => (
  <section id="nav-strategic-lending" className="relative overflow-hidden py-24">
    {/* Background image */}
    <img
      src={constructionBg}
      alt=""
      aria-hidden="true"
      className="absolute inset-0 h-full w-full"
      style={{ objectFit: "cover" }}
    />

    {/* Dark overlay */}
    <div className="absolute inset-0" style={{ backgroundColor: "rgba(50,50,50,0.75)" }} />

    {/* Content on top */}
    <div className="relative px-6 py-14 md:px-12 lg:px-24">
      <h2 className="text-center font-bold" style={{ color: "#ffffff" }}>
        Strategic Lending Solutions for Builders
      </h2>
      <p className="mx-auto mt-6 text-center" style={{ lineHeight: 1.7, color: "#ffffff", maxWidth: "1100px" }}>
        We partner with builders throughout Northwest Montana and the Flathead Valley to provide smart financing
        solutions that help move inventory and drive consistent sales. By combining forward thinking rate strategies
        with reliable execution, we help builders create stronger buyer demand and more predictable closings.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 310px)",
          gap: "40px",
          justifyContent: "center",
          marginTop: "40px",
        }}
      >
        {strategicLendingItems.map((item) => (
          <div
            key={item.title}
            className="rounded-lg border border-gray-see bg-white text-center shadow-sm flex flex-col items-center justify-center"
            style={{ width: "310px", height: "310px", padding: "24px" }}
          >
            <h3 className="font-bold" style={{ color: "#323232" }}>
              {item.title}
            </h3>
            <p className="mt-4" style={{ lineHeight: 1.6 }}>
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default StrategicLending;
